const hasValue = (value) => value !== null && value !== undefined && String(value).trim() !== '';
const hasEnteredValue = (row) => Object.values(row || {}).some(hasValue);
const hasNightlyAmount = (rates = []) => Array.isArray(rates) && rates.some((rate) => hasValue(rate?.amount));
const PAYMENT_INPUT_KEYS = ['amount', 'payment_method', 'cash_receipt_issue_no', 'cash_receipt_amount', 'card_deposit_memo'];

function requireRowFields(rows, label, fields, isVisible) {
  const enteredRows = rows.filter(hasEnteredValue);
  for (let i = 0; i < enteredRows.length; i += 1) {
    for (const field of fields) {
      if (isVisible(field.fieldKey) && !hasValue(enteredRows[i]?.[field.key])) {
        return `${label} #${i + 1} ${field.label} 필수`;
      }
    }
  }
  return null;
}

function validatePayments(payments = []) {
  const enteredRows = payments.filter((row) => PAYMENT_INPUT_KEYS.some((key) => hasValue(row?.[key])));
  for (let i = 0; i < enteredRows.length; i += 1) {
    const row = enteredRows[i];
    if (hasValue(row.amount) && !hasValue(row.payment_date)) {
      return `결제 #${i + 1} 금액이 입력된 결제는 지불일을 입력해 주세요.`;
    }
    if (hasValue(row.amount) && !hasValue(row.payment_method)) {
      return `결제 #${i + 1} 금액이 입력된 결제는 지불수단을 입력해 주세요.`;
    }
  }
  return null;
}

function hasHotelEnteredValue(row = {}) {
  const { nightly_rates, total_cost, ...rest } = row;
  return Object.values(rest).some(hasValue) || hasValue(total_cost) || hasNightlyAmount(nightly_rates);
}

function validateHotels(hotels = [], isVisible) {
  const enteredRows = hotels.filter(hasHotelEnteredValue);
  const requiresAmount = isVisible('hotel.total_cost') || isVisible('hotel.nightly_rates');
  if (!requiresAmount) return null;
  for (let i = 0; i < enteredRows.length; i += 1) {
    const row = enteredRows[i];
    if (!hasNightlyAmount(row.nightly_rates) && !hasValue(row.total_cost)) {
      return `호텔 #${i + 1} 일별요금 필수`;
    }
  }
  return null;
}

export function validateReservationForm({ master, flights, cars, hotels, payments, isVisible = () => true }) {
  if (!hasValue(master.travel_code)) return '여행코드 필수';
  if (!hasValue(master.customer_name)) return '고객명 필수';
  if (!hasValue(master.reservation_date)) return '예약일 필수';

  return requireRowFields(flights, '항공', [
    { key: 'passenger_type', fieldKey: 'flight.passenger_type', label: '구분' },
    { key: 'base_fare', fieldKey: 'flight.base_fare', label: '항공운임' },
    { key: 'fuel_surcharge', fieldKey: 'flight.fuel_surcharge', label: '유류할증료' },
    { key: 'taxes', fieldKey: 'flight.taxes', label: '공항세' },
  ], isVisible) || requireRowFields(cars, '렌트카', [
    { key: 'total_cost', fieldKey: 'car.total_cost', label: '총액' },
  ], isVisible) || validateHotels(hotels, isVisible) || validatePayments(payments);
}
